/** §14.5.1. Index 0 is the Master Ball (Core NFT); 1–9 are Token-2022 mints. Caps are regenerated and checked by gen1-data. */
export const RARE_ITEM_COUNT = 10;

export interface RareItemDef {
  index: number;
  name: string;
  gameId: number;
  symbol: string;
  cap: number;
}

export const RARE_ITEMS: readonly RareItemDef[] = [
  { index: 0, name: "Master Ball", gameId: 0x01, symbol: "MBALL", cap: 1 },
  { index: 1, name: "Rare Candy", gameId: 0x28, symbol: "RCANDY", cap: 13 },
  { index: 2, name: "Nugget", gameId: 0x31, symbol: "NUGGET", cap: 10 },
  { index: 3, name: "PP Up", gameId: 0x4f, symbol: "PPUP", cap: 6 },
  { index: 4, name: "Max Revive", gameId: 0x36, symbol: "MAXREV", cap: 6 },
  { index: 5, name: "Moon Stone", gameId: 0x0a, symbol: "MOONSTN", cap: 5 },
  { index: 6, name: "Ether", gameId: 0x50, symbol: "ETHER", cap: 4 },
  { index: 7, name: "Max Ether", gameId: 0x51, symbol: "MAXETH", cap: 4 },
  { index: 8, name: "Elixer", gameId: 0x52, symbol: "ELIXER", cap: 5 },
  { index: 9, name: "Max Elixer", gameId: 0x53, symbol: "MAXELX", cap: 5 },
];

export function rareIndexForGameId(gameId: number): number {
  return RARE_ITEMS.findIndex((r) => r.gameId === gameId);
}
